export default "__VITE_ASSET__CBo$TFwX__"